import { useEffect, useState } from "react";

const split = (ms) => {
  const total = Math.max(0, Math.floor(ms / 1000));
  return {
    days: Math.floor(total / 86400),
    hours: Math.floor((total % 86400) / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
    done: total === 0,
  };
};

/** Live countdown to an ISO datetime (ticks every second). */
export const useCountdown = (targetIso) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!targetIso) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [targetIso]);
  if (!targetIso) return null;
  return split(new Date(targetIso).getTime() - now);
};

export const pad2 = (n) => String(n).padStart(2, "0");
